import BaseResource from '@/app-core/lib/data/resource/BaseResource'
import {collect} from '@/app-core/lib/utils/array'
import CustomerAddressModel from '@/app-core/api/models/customer/CustomerAddressModel'
import CustomerInfoModel from '@/app-core/api/models/customer/CustomerInfoModel'

export default class CustomerResource extends BaseResource {
  constructor(payload = {}) {
    super(payload)

    this.Addresses = collect(payload.Addresses ?? [], CustomerAddressModel)
    this.Info = new CustomerInfoModel(payload.Info)
  }

  /* PROPERTIES */

  /* METHODS */
}
